//
//
//
//
//


import WX_API from '@/utils/wx_api'

export default {
    mounted (options) {
        console.log('mounted', this.title)
        WX_API.setTitle(this.title, this.show_app_name)
    },
    updated () {
        console.log('updated', this.title)
    },
    activated () {
        console.log('activated', this.title)
        WX_API.setTitle(this.title, this.show_app_name)
    },
    watch: {
        title (latest) {
            console.log(latest)
            WX_API.setTitle(latest, this.show_app_name)
        }
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        show_app_name: {
            type: Boolean,
            default: true
        },
        className: {
            type: String,
            default () {
                return ''
            }
        },
        has_own_timeline: Boolean
    },
    components: {
    }
}
